import colors from "../../base/colors";

const {  secondary } = colors;
export default {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      color: secondary.main,
    },
  },
};